/**
 * @generated SignedSource<<36a9a6ff8210497a62b0b9bbf92174c6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateCustomPlanForSellerTaskInput = {
  masterSalesChannelID?: string | null;
  secondarySalesChannelID?: string | null;
};
export type salesChannelSwitchQueriesGenerateCreateCustomPlanForSellerTaskMutation$variables = {
  input: CreateCustomPlanForSellerTaskInput;
};
export type salesChannelSwitchQueriesGenerateCreateCustomPlanForSellerTaskMutation$data = {
  readonly generateCreateCustomPlanForSellerTask: {
    readonly taskID: number;
  } | null;
};
export type salesChannelSwitchQueriesGenerateCreateCustomPlanForSellerTaskMutation = {
  response: salesChannelSwitchQueriesGenerateCreateCustomPlanForSellerTaskMutation$data;
  variables: salesChannelSwitchQueriesGenerateCreateCustomPlanForSellerTaskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProductSwitcherTaskOutput",
    "kind": "LinkedField",
    "name": "generateCreateCustomPlanForSellerTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelSwitchQueriesGenerateCreateCustomPlanForSellerTaskMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelSwitchQueriesGenerateCreateCustomPlanForSellerTaskMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "a584949b014c15ec5836aa35ad42e5a0",
    "id": null,
    "metadata": {},
    "name": "salesChannelSwitchQueriesGenerateCreateCustomPlanForSellerTaskMutation",
    "operationKind": "mutation",
    "text": "mutation salesChannelSwitchQueriesGenerateCreateCustomPlanForSellerTaskMutation(\n  $input: CreateCustomPlanForSellerTaskInput!\n) {\n  generateCreateCustomPlanForSellerTask(input: $input) {\n    taskID\n  }\n}\n"
  }
};
})();

(node as any).hash = "15493a9551dc0330e24dd1e1a807e191";

export default node;
